// extracted by mini-css-extract-plugin
export default {"Lines":"Lines_Lines__kiiz5","Lines__new":"Lines_Lines__new__Gmb6D","Lines__table":"Lines_Lines__table__Be6t1"};